import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PlansDataService {

  constructor(
    private http: HttpClient
  ) {
  }

  getPlans(apiUrl: string, id: any): Observable<any> {
    return this.http.get(`${apiUrl}/storage/planset/${id}`);
  }
}
